import websiteJson from "../../config/website.json";

const addGTM = (branch) => {
	console.log("im get branch", websiteJson.GTM[branch]);
	const script = document.createElement("script");
	const gtmCode = `
	(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
	new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
	j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
	'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	})(window,document,'script','dataLayer','${websiteJson.GTM[branch]}');
	`;
	script.appendChild(document.createTextNode(gtmCode));
	document.head.appendChild(script);

	const noscript = document.createElement("noscript");
	const iframe = document.createElement("iframe");
	iframe.setAttribute(
		"src",
		`https://www.googletagmanager.com/ns.html?id=${
			websiteJson.GTM[branch]
		}`,
	);
	iframe.setAttribute("height", "0");
	iframe.setAttribute("width", "0");
	iframe.setAttribute("style", "display:none;visibility:hidden");
	noscript.appendChild(iframe);
	document.body.appendChild(noscript);
};

const getBranch = () => {
	if (process.env.DEV) {
		return process.env.BRANCH;
	}

	if (process.env.DEMO) {
		return {
			xin: "xinzhuang",
			tao: "taoyuan",
			kao: "kaohsiung",
			hua: "hualien",
		}[window.location.hostname.substr(0, 3)];
	}

	return window.location.hostname.split(".")[0];
};

addGTM(getBranch());

export default {
	branch: getBranch(),
	language: window.location.pathname.split("/")[1],
};



// WEBPACK FOOTER //
// ./src/js/urlParser.js